import { render } from "./DropdownMenu.vue?vue&type=template&id=b1a8e756&scoped=true&ts=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=b1a8e756&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a8e756"]])

export default __exports__